var map = {
	"./news-album.png": "RhSr",
	"./news-logo.png": "XcyF",
	"./news-qrcode.png": "lJJS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2F9Q";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images-en ^\.\/.*$
// module id = 2F9Q
// module chunks = 1